import { CSSProperties } from 'react';

import batchProcessingImage from './images/batchprocessing_status.svg';
import cohortDraftImage from './images/cohortDraft.svg';
import cohortErrorImage from './images/cohortError.svg';
import cohortFinalImage from './images/cohortFinal.svg';
import cohortProcessedImage from './images/cohortProcessed.svg';
import cohortProcessingImage from './images/cohortProcessing.svg';
import failedImage from './images/failed_status.svg';
import processedImage from './images/processed_status.svg';

export const STATUS_LABEL_MAPPING: Record<string, string> = {
  active: 'Active',
  available: 'Available',
  final: 'Final',
  processing: 'Processing',
  pending: 'Pending',
  locked: 'Locked',
  in_design: 'In Design',
  draft: 'Draft',
  error: 'Error',
  enrolled: 'Enrolled',
  bypass: 'Bypass',
  ready: 'Ready',
  received: 'Received',
  rejected: 'Rejected',
  processed: 'Processed',
  failed: 'Failed',
  batch_processing: 'Processing',
  cohortstatusfinal: 'Final',
  cohortstatusprocessing: 'Processing',
  cohortstatusprocessed: 'Processed',
  cohortstatusdraft: 'Draft',
  cohortstatuserror: 'Error',
};

export const STATUS_BACKGROUND_MAPPING: Record<string, CSSProperties> = {
  active: { backgroundColor: '#00800099' },
  available: { backgroundColor: '#659d1f' },
  final: { backgroundColor: '#66d3ee' },
  processing: { backgroundColor: '#00b5e2' },
  pending: { backgroundColor: '#f6c44a' },
  locked: { backgroundColor: '#252a36' },
  in_design: { backgroundImage: `url("${cohortDraftImage}")` },
  draft: { backgroundImage: `url("${cohortDraftImage}")` },
  error: { backgroundColor: '#f14c2e' },
  enrolled: { backgroundColor: '#008800' },
  bypass: { backgroundColor: '#01579b' },
  ready: { backgroundColor: '#008000' },
  received: { backgroundColor: '#00b5e2' },
  rejected: { backgroundColor: '#f14c2e' },
  processed: { backgroundImage: `url("${processedImage}")` },
  failed: { backgroundImage: `url("${failedImage}")` },
  batch_processing: { backgroundImage: `url("${batchProcessingImage}")` },
  cohortstatusfinal: { backgroundImage: `url("${cohortFinalImage}")` },
  cohortstatusprocessing: { backgroundImage: `url("${cohortProcessingImage}")` },
  cohortstatusprocessed: { backgroundImage: `url("${cohortProcessedImage}")` },
  cohortstatusdraft: { backgroundImage: `url("${cohortDraftImage}")` },
  cohortstatuserror: { backgroundImage: `url("${cohortErrorImage}")` },
};
